export const messages = {
  en: {
    simplifyNotepadManage: {
      title: 'Owner Feedback',
      back: 'Back',
      register: 'Register',
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      recordTime: 'Record Time',
      registrant: 'Registrant',
      content: 'Content',
      operation: 'Operation',
      completed: 'Completed',
      following: 'Following',
      transferred: 'Transferred to repair',
      follow: 'Follow up',
      progress: 'Progress',
      transferRepair: 'Transfer to repair',
      repairDetail: 'Repair Detail',
      edit: 'Edit',
      delete: 'Delete',
      tip: 'Tip: Please register at the business acceptance page'
    },
    addNotepad: {
      title: 'Register',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      type: 'Type',
      content: 'Content',
      roomRequired: 'Room is required',
      contactRequired: 'Contact is required',
      phoneRequired: 'Phone is required',
      phoneFormat: 'Invalid phone format',
      typeRequired: 'Type is required',
      contentRequired: 'Content is required',
      contentMaxLength: 'Content cannot exceed 256 characters',
      typePlaceholder: 'Please select feedback type',
      contentPlaceholder: 'Please enter content'
    },
  },
  zh: {
    simplifyNotepadManage: {
      title: '业主反馈',
      back: '返回',
      register: '登记',
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      recordTime: '记录时间',
      registrant: '登记人',
      content: '登记内容',
      operation: '操作',
      completed: '完成',
      following: '跟进中',
      transferred: '已转报修单',
      follow: '跟进',
      progress: '进度',
      transferRepair: '转报修单',
      repairDetail: '报修详情',
      edit: '修改',
      delete: '删除',
      tip: '温馨提示：请到业务受理页面登记'
    },
    addNotepad: {
      title: '登记',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      type: '类型',
      content: '内容',
      roomRequired: '房屋不能为空',
      contactRequired: '联系人不能为空',
      phoneRequired: '联系电话不能为空',
      phoneFormat: '联系电话格式错误',
      typeRequired: '类型不能为空',
      contentRequired: '内容不能为空',
      contentMaxLength: '内容不能超过256字符',
      typePlaceholder: '请选择反馈类型',
contentPlaceholder: '请填写内容'
    }
  },
  'zh-TW': {
    simplifyNotepadManage: {
      title: '業主反饋',
      back: '返回',
      register: '登記',
      type: '類型',
      room: '房屋',
      contact: '聯繫人',
      phone: '聯繫電話',
      status: '狀態',
      recordTime: '記錄時間',
      registrant: '登記人',
      content: '登記內容',
      operation: '操作',
      completed: '完成',
      following: '跟進中',
      transferred: '已轉報修單',
      follow: '跟進',
      progress: '進度',
      transferRepair: '轉報修單',
      repairDetail: '報修詳情',
      edit: '修改',
      delete: '刪除',
      tip: '溫馨提示：請到業務受理頁面登記'
    },
    addNotepad: {
      title: '登記',
      room: '房屋',
      contact: '聯繫人',
      phone: '聯繫電話',
      type: '類型',
      content: '內容',
      roomRequired: '房屋不能為空',
      contactRequired: '聯繫人不能為空',
      phoneRequired: '聯繫電話不能為空',
      phoneFormat: '聯繫電話格式錯誤',
      typeRequired: '類型不能為空',
      contentRequired: '內容不能為空',
      contentMaxLength: '內容不能超過256字符',
      typePlaceholder: '請選擇反饋類型',
      contentPlaceholder: '請填寫內容'
    }
  }
}